import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-expediente-clinico-movil',
  templateUrl: './menu-expediente-clinico-movil.component.html',
  styles: []
})
export class MenuExpedienteClinicoMovilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
